import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from '@/functions/Util';

export default class GerenciarUsuariosValidation extends DefaultValidation {
    constructor(msgs) {
        super(msgs);
    }

    validate(usuario, refs, usuarioIntegracao) {
        let validated = true;

        if (!usuarioIntegracao) {
            if (
                isNull(usuario.nome) ||
                isNull(usuario.email) ||
                isNull(usuario.login) ||
                (isNull(usuario.senha) && isNull(usuario.idusuario))
            ) {
                refs.nomeInput.focusedOut = true;
                refs.emailInput.focusedOut = true;
                refs.loginInput.focusedOut = true;
                if (usuario.idusuario == null) refs.senhaInput.focusedOut = true;
                validated = false;
            }
        }

        if (isNull(usuario.idusuariocargo) || isNull(refs.cargoSelect.value)) {
            validated = false;
            refs.cargoSelect.focusedOut = true;
        }

        /**
         * @70830 - validacao da cidade, endereco e bairro.
         */
        if (isNull(usuario.idcidade) || isNull(refs.cidadeSelect.value)) {
            validated = false;
            refs.cidadeSelect.focusedOut = true;
        }

        if (isNull(usuario.endereco) || isNull(refs.enderecoInput.value)) {
            validated = false;
            refs.enderecoInput.focusedOut = true;
        }

        if (isNull(usuario.bairro) || isNull(refs.bairroInput.value)) {
            validated = false;
            refs.bairroInput.focusedOut = true;
        }

        return validated;
    }
}
